
import React from 'react';
import { CertificatesTableRow } from './CertificatesTableRow';
import { NoRows } from 'components/layout/Table/NoRows';

function CertificatesTableBody(props){
    const renderRows = () => {
        const { certificates } = props;
        if (!Array.isArray(certificates) || certificates.length === 0) {
          return <NoRows colSpan="8"/>;
        }
    
        return certificates.map(renderRow);
      };
    
      const renderRow = (certificate, index) => {
        
        return (
          <CertificatesTableRow 
            key = {index}
            certificate = {certificate}
            index= { index }
            shouldRenderFields={props.shouldRenderFields}
            actionCallback={props.actionCallback}
          />
        )
      }

      return (
        <tbody>
        { renderRows() }
        </tbody>
      )
}

export {CertificatesTableBody}

